module.exports = __webpack_public_path__ + "static/media/paso1.850bc14d.svg";